import * as React from "react";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import CandidateForm from "./components/candidate/CandidateForm";
import CandidateList from "./components/candidate/CandidateList";
import MyProfile from "./components/candidate/myProfile/MyProfile";
import CourseForm from "./components/course/CourseForm";
import CourseList from "./components/course/CourseList";
import ExamForm from "./components/exam/ExamForm";
import ExamList from "./components/exam/ExamList";
import ExamDayForm from "./components/examDay/ExamDayForm";
import ExamSessionForm from "./components/examSession/ExamSessionForm";
import ExamSessionList from "./components/examSession/ExamSessionList";
import ExamSessionLocationForm from "./components/examSession/ExamSessionLocationForm";
import ExamSessionCandidateForm from "./components/examSession/examSessionCandidate/ExamSessionCandidateForm";
import CorrectionExamsScheduler from "./components/examsScheduler/correctionExams/CorrectionExamsScheduler";
import ExpertExamsScheduler from "./components/examsScheduler/expertExams/ExpertExamsScheduler";
import OralExamsScheduler from "./components/examsScheduler/oralExams/OralExamsScheduler";
import WrittenExamsScheduler from "./components/examsScheduler/writtenExams/WrittenExamsScheduler";
import ExpertCorrectionAvailabilitySetup from "./components/expert/ExpertCorrectionAvailabilitySetup";
import ExpertExaminationAvailabilitySetup from "./components/expert/ExpertExaminationAvailabilitySetup";
import MyExpertProfile from "./components/expert/MyExpertProfile/MyExpertProfile";
import CandidateHome from "./components/home/CandidateHome";
import ExpertHome from "./components/home/ExpertHome";
import Home from "./components/home/Home";
import CancellationForm from "./components/internalTask/Cancellation/CancellationForm";
import LocationForm from "./components/location/LocationForm";
import LocationList from "./components/location/LocationList";
import Login from "./components/login/Login";
import ModuleForm from "./components/module/ModuleForm";
import ModuleList from "./components/module/ModuleList";
import UploadDocumentsForm from "./components/personTask/uploadDocuments/UploadDocumentsForm";
import RoomForm from "./components/room/RoomForm";
import RoomAssignmentForm from "./components/roomAssignment/RoomAssignmentForm";
import StartCertificationWizard from "./components/startCertificationWizard_new/StartCertificationWizard";
import ExpertsCorrectionExamAssignmentBoard from "./components/userRoomAssignmentBoard/ExpertsCorrectionExamAssignmentBoard";
import ExpertsOralExamAssignmentBoard from "./components/userRoomAssignmentBoard/ExpertsOralExamAssignmentBoard";
import ProctorsOralPreparationAssignmentBoard from "./components/userRoomAssignmentBoard/ProctorsOralPreparationAssignmentBoard";
import ProctorsWrittenExamAssignmentBoard from "./components/userRoomAssignmentBoard/ProctorsWrittenExamAssignmentBoard";
import { UserRoomAssignmentType } from "./data/constants";
import { PersonType } from "./model/PersonType";
import LifeExamsPage from "./components/lifeExams/LifeExamsPage";
import ExamSessionBuilder from "./components/examSession/builder/ExamSessionBuilder";

export const LifeExamSessionLinkRoute = "/life"

export const routesPaths = {
  root: () => "/",
  login: () => "/login",
  internalLogin: () => "/login/internal",
  externalLogin: () => "/login/external",
  candidate: (candidateId: string) => `/candidate/${candidateId}`,
  candidates: () => "/candidate",
  candidateHome: () => "/candidateHome",
  candidateWizard: () => "/startCertification",
  course: (courseId: string) => `/course/${courseId}`,
  courses: () => "/courses",
  expert: (expertId: string) => `/expert/${expertId}`,
  expertHome: () => "/expertHome",
  location: (locationId: string, examSessionId?: string) =>
    examSessionId ? `/examSession/${examSessionId}/location/${locationId}` : `/location/${locationId}`,
  locations: () => "/location",
  exam: (examId: string) => `/exam/${examId}`,
  exams: () => "/exam",
  examSession: (examSessionId: string, isLife?: string) => isLife ? `/examSession/${examSessionId}/${isLife}` : `/examSession/${examSessionId}`,
  examSessionBuilder: () => `/examSession/build`,
  examSessions: () => "/examSession",
  examSessionLocation: (examSessionId: string, locationId: string) =>
    `/examSession/${examSessionId}/location/${locationId}`,
  examSessionCandidate: (examSessionCandidateId: string, moduleId: string) =>
    `/examSessionCandidate/${examSessionCandidateId}/module/${moduleId}`,
  module: (moduleId: string) => `/module/${moduleId}`,
  modules: () => "/modules",
  room: (locationId: string, roomId: string) => `/location/${locationId}/room/${roomId}`,
  examDay: (examSessionId: string, locationId: string, examDayId: string) =>
    `/examSession/${examSessionId}/location/${locationId}/examDay/${examDayId}`,
  roomAssignment: (examSessionId: string, locationId: string, examDayId: string, roomAssignmentId: string) =>
    `/examSession/${examSessionId}/location/${locationId}/examDay/${examDayId}/roomAssignment/${roomAssignmentId}`,
  startCertification: () => `/startCertification`,
  expertAvailability: (examSessionId: string) => `/expertAvailability/${examSessionId}`,
  expertCorrectionAvailability: (examSessionId: string) => `/expertAvailabilityCorrection/${examSessionId}`,
  employeeOralExamsSchedule: (examSessionId: string, locationId: string) =>
    `/examSession/${examSessionId}/location/${locationId}/scheduleOralExams`,
  expertExamsSchedule: (examSessionId: string) => `/examSession/${examSessionId}/examsSchedule`,
  userRoomAssignment: (examSessionId: string, examDayId: string, userRoomAssignmentType: UserRoomAssignmentType) =>
    `/userRoomAssignment/${examSessionId}/examDay/${examDayId}/assignmentType/${userRoomAssignmentType}`,
  userProfile: (userId: string = "") => `/myProfile/${userId}`,
  expertProfile: (userId: string = "") => `/myExpertProfile/${userId}`,
  cancellationInternalTask: (internalTaskId: string) => `/internalTask/Cancellation/${internalTaskId}`,
  employeeWrittenExamsSchedule: (examSessionId: string, locationId: string) =>
    `/examSession/${examSessionId}/location/${locationId}/scheduleWrittenExams`,
  employeeCorrectionExamsSchedule: (examSessionId: string, locationId: string) =>
    `/examSession/${examSessionId}/location/${locationId}/scheduleCorrectionExams`,
  uploadDocumentsPersonTask: (examSessionId: string, moduleId: string) =>
    `/task/uploadDocuments/${examSessionId}/${moduleId}`,
  life: (languageKey: string, examSessionId?: string) =>{
    return `${LifeExamSessionLinkRoute}/${languageKey}${examSessionId ? `/${examSessionId}` : ""}`;
  }
};

const Routes: React.FC = () => (
  <Switch>
    <Route path={routesPaths.login()} component={Login} exact={true} />
    <PrivateRoute
      path={routesPaths.candidates()}
      component={CandidateList}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.candidate(":candidateId")}
      component={CandidateForm}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.candidateHome()}
      component={CandidateHome}
      exact={true}
      personTypesAllowed={[PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.examSessionCandidate(":examSessionCandidateId", ":moduleId")}
      component={ExamSessionCandidateForm}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.course(":courseId")}
      component={CourseForm}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.courses()}
      component={CourseList}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.examDay(":examSessionId", ":locationId", ":examDayId")}
      component={ExamDayForm}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.examSessionBuilder()}
      component={ExamSessionBuilder}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.examSession(":examSessionId")}
      component={ExamSessionForm}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.examSession(":examSessionId", ":isLife")}
      component={ExamSessionForm}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.examSessions()}
      component={ExamSessionList}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.exam(":examId")}
      component={ExamForm}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.exams()}
      component={ExamList}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.module(":moduleId")}
      component={ModuleForm}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.modules()}
      component={ModuleList}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.expertHome()}
      component={ExpertHome}
      exact={true}
      personTypesAllowed={[PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.location(":locationId")}
      component={LocationForm}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.location(":locationId", ":examSessionId")}
      component={ExamSessionLocationForm}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.locations()}
      component={LocationList}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.room(":locationId", ":roomId")}
      component={RoomForm}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.roomAssignment(":examSessionId", ":locationId", ":examDayId", ":roomAssignmentId")}
      component={RoomAssignmentForm}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.root()}
      component={Home}
      exact={true}
      personTypesAllowed={[PersonType.Internal, PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.startCertification()}
      component={StartCertificationWizard}
      exact={true}
      personTypesAllowed={[PersonType.Internal, PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.expertAvailability(":examSessionId")}
      component={ExpertExaminationAvailabilitySetup}
      exact={true}
      personTypesAllowed={[PersonType.Internal, PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.expertCorrectionAvailability(":examSessionId")}
      component={ExpertCorrectionAvailabilitySetup}
      exact={true}
      personTypesAllowed={[PersonType.Internal, PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.expertExamsSchedule(":examSessionId")}
      component={ExpertExamsScheduler}
      exact={true}
      personTypesAllowed={[PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.userRoomAssignment(":examSessionId", ":examDayId", UserRoomAssignmentType.WrittenExam)}
      component={ProctorsWrittenExamAssignmentBoard}
      exact={true}
      personTypesAllowed={[PersonType.Internal, PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.userRoomAssignment(":examSessionId", ":examDayId", UserRoomAssignmentType.OralPreparation)}
      component={ProctorsOralPreparationAssignmentBoard}
      exact={true}
      personTypesAllowed={[PersonType.Internal, PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.userRoomAssignment(":examSessionId", ":examDayId", UserRoomAssignmentType.OralExam)}
      component={ExpertsOralExamAssignmentBoard}
      exact={true}
      personTypesAllowed={[PersonType.Internal, PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.userRoomAssignment(":examSessionId", ":examDayId", UserRoomAssignmentType.Correction)}
      component={ExpertsCorrectionExamAssignmentBoard}
      exact={true}
      personTypesAllowed={[PersonType.Internal, PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.userProfile()}
      component={MyProfile}
      exact={true}
      personTypesAllowed={[PersonType.Internal, PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.expertProfile()}
      component={MyExpertProfile}
      exact={true}
      personTypesAllowed={[PersonType.Internal, PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.cancellationInternalTask(":internalTaskId")}
      component={CancellationForm}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.employeeOralExamsSchedule(":examSessionId", ":locationId")}
      component={OralExamsScheduler}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.employeeWrittenExamsSchedule(":examSessionId", ":locationId")}
      component={WrittenExamsScheduler}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.employeeCorrectionExamsSchedule(":examSessionId", ":locationId")}
      component={CorrectionExamsScheduler}
      exact={true}
      personTypesAllowed={[PersonType.Internal]}
    />
    <PrivateRoute
      path={routesPaths.uploadDocumentsPersonTask(":examSessionId", ":moduleId")}
      component={UploadDocumentsForm}
      exact={true}
      personTypesAllowed={[PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.life(":languageKey")}
      component={LifeExamsPage}
      exact={true}
      personTypesAllowed={[PersonType.Candidate, PersonType.Expert]}
    />
    <PrivateRoute
      path={routesPaths.life(":languageKey", ":examSessionId")}
      component={LifeExamsPage}
      exact={true}
      personTypesAllowed={[PersonType.Candidate, PersonType.Expert]}
    />
  </Switch>
);

export default Routes;
